"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UserProfileEditScreen_1 = require("./UserProfileEditScreen");

exports.UserProfileEditScreen = UserProfileEditScreen_1.default;